/*
 * Product（商品詳細）固有スクリプト
 * 商品オプション（_sc.product-option メタフィールド駆動、本番実装を移植・2026-08-19）、
 * 画像ギャラリー、アコーディオンの開閉、数量、カート追加を扱う。
 * 「カートに入れる」は独自Ajax Cart API（cart-api.js）で送信し、ページ遷移はしない
 * （本番サイトもAjaxでカートに追加される方式であることを確認済み。ただし本番の
 * 「右からカートパネルがスライド表示」という見た目は今回は採用しない方針）。
 * お気に入り(☆)ボタンは対象外機能のため、main-product.liquid側でコメントアウトして
 * 非表示にしている（2026-08-24。何も起きないボタンを表示するのは紛らわしいため）。
 */
(function (SANBY) {
  const { escapeHtml } = SANBY.utils;
  const { addItem } = SANBY.cartApi;
  const { loadRecommendationBlocks, bindAddToCartButtons } = SANBY.recommendations;

  // 版下エディタ（backend/cloudflare/worker/assets/stamp-editor/）のホスト先。
  // Cloudflare Worker URL自体はどの環境でも同じなので定数で固定。パスコードのみ
  // ドメインごとに変わるため、テーマ設定（settings.stamp_editor_passcode）経由で渡す
  // （data-product-option-configのdata属性、下記参照）。
  const STAMP_EDITOR_BASE = "https://backend.cocomo-s.workers.dev/stamp-editor/";

  // ================= 商品オプション（_sc.product-option） =================
  // 本番の既存実装（scProductOption-*）を移植。変更点は2つだけ：
  // ①送信部分をネイティブのform submitではなく独自Ajax Cart API（addItem）に差し替え
  // （2026-08-19方針決定、本番も実際はAjaxのため）。②価格に影響するオプション
  // （hidden型・name:"variation"）の反映先を、本番のネイティブ<select name="id">操作から、
  // product.variantsを直接検索してdata-variant-id-inputへ反映する方式に変更
  // （このテーマは独自UIのみでネイティブのバリエーション選択UIを持たないため）。
  function initProductOptions() {
    const configEl = document.querySelector("[data-product-option-config]");
    if (!configEl) return;

    let formConfig, productVariants, variantPrices;
    try {
      formConfig = JSON.parse(configEl.textContent);
      productVariants = JSON.parse(document.querySelector("[data-product-variants]").textContent);
      variantPrices = JSON.parse(document.querySelector("[data-product-variant-prices]").textContent);
    } catch (e) {
      console.error("商品オプション設定の読み込みに失敗しました:", e);
      return;
    }

    if (!Array.isArray(formConfig) || formConfig.length === 0) return;

    const fileBaseUrl = configEl.dataset.assetBaseUrl || "";
    const getFullImgUrl = (name) => (name && !name.startsWith("http")) ? `${fileBaseUrl}${name}.webp` : name;
    const stampEditorPasscode = configEl.dataset.stampEditorPasscode || "";
    const productTitle = configEl.dataset.productTitle || "";
    const stampGuideUrl = configEl.dataset.stampGuideUrl || "";

    const container = document.getElementById("scProductOption-CustomPropertiesForm");
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!container || !productForm) return;

    const variantIdInput = productForm.querySelector("[data-variant-id-input]");
    const priceEl = document.querySelector("[data-price]");
    const basePrice = priceEl ? priceEl.textContent : "";
    // 版下エディタのボタン参照・モーダル監視は、renderFields()を後で何度も呼び直しても
    // （カート追加後のリセット時など）使い回せるよう、renderFields()の外側で保持する
    let stampReturnBtn = null;
    let stampModalObserver = null;

    function checkCondition(cond, data) {
      if (!cond) return true;
      if (cond.and) return cond.and.every((c) => checkCondition(c, data));
      if (cond.or) return cond.or.some((c) => checkCondition(c, data));
      if (cond.key) return String(data[cond.key]) === String(cond.value);
      return true;
    }

    function findVariantByTitle(title) {
      return productVariants.find(
        (v) => v.title.trim() === title || v.option1 === title || v.option2 === title || v.option3 === title
      );
    }

    // variationフィールドでバリエーションが切り替わった際、そのバリエーションが
    // 売り切れ（available: false）なら「カートに入れる」を押せなくしSOLD OUT表示にする
    // （main-product.liquid側の初期表示＝デフォルトバリエーションのフォールバックを上書きする）。
    function setCartButtonAvailability(available) {
      const addBtn = productForm.querySelector("[data-add-cart]");
      if (!addBtn) return;
      if (!addBtn.dataset.defaultLabel) addBtn.dataset.defaultLabel = available ? addBtn.textContent : "カートに入れる";
      if (available) {
        addBtn.disabled = false;
        addBtn.removeAttribute("data-sold-out");
        addBtn.textContent = addBtn.dataset.defaultLabel;
      } else {
        addBtn.disabled = true;
        addBtn.setAttribute("data-sold-out", "");
        addBtn.textContent = "SOLD OUT";
      }
    }

    function evaluateConditions() {
      const currentData = {};
      container.querySelectorAll('[name^="properties["]').forEach((el) => {
        const key = el.name.replace("properties[", "").replace("]", "");
        currentData[key] = el.type === "checkbox" ? el.checked : el.value;
      });

      let isVariationOverridden = false;
      let selectedVariant = null;

      formConfig.forEach((field, index) => {
        const wrapper = container.querySelectorAll(".scProductOption-field-wrapper")[index];
        const inputs = wrapper.querySelectorAll("input, textarea, select");
        const isVisible = checkCondition(field.condition, currentData);

        if (field.condition) {
          if (isVisible) {
            wrapper.classList.remove("is-hidden");
            inputs.forEach((input) => (input.disabled = false));
          } else {
            wrapper.classList.add("is-hidden");
            inputs.forEach((input) => (input.disabled = true));
          }
        } else {
          inputs.forEach((input) => (input.disabled = false));
        }

        if (field.type === "hidden" && field.name === "variation" && isVisible) {
          isVariationOverridden = true;
          const matched = findVariantByTitle(field.default);
          if (matched && variantIdInput) {
            variantIdInput.value = matched.id;
            selectedVariant = matched;
            if (priceEl && variantPrices[matched.id]) {
              priceEl.textContent = variantPrices[matched.id];
            }
          }
        }
      });

      if (!isVariationOverridden && variantIdInput) {
        selectedVariant = productVariants[0] || null;
        variantIdInput.value = selectedVariant ? selectedVariant.id : variantIdInput.value;
        if (priceEl) priceEl.textContent = basePrice;
      }

      setCartButtonAvailability(selectedVariant ? selectedVariant.available : true);
    }

    // フィールドのHTML生成とイベント配線一式。カート追加成功後のリセット（ユーザー要望、
    // 2026-09-30）でも同じ処理を丸ごと再実行して初期状態に戻す（container.innerHTMLを
    // formConfigから作り直すだけなので、値のクリアし忘れが起きない）
    function renderFields() {
    let formHtml = "";
    let hasStampEditorField = false;
    formConfig.forEach((field) => {
      if (field.type === "stamp-editor") hasStampEditorField = true;
      const isHidden = field.type === "hidden";
      formHtml += `<div class="scProductOption-field-wrapper ${isHidden ? "is-hidden" : ""} ${field.type === "stamp-editor" ? "scProductOption-field-wrapper--stamp" : ""}" data-field-wrapper>`;

      if (field.type === "separator") {
        formHtml += `<hr class="scProductOption-separator">`;
      } else if (isHidden) {
        formHtml += `<input type="hidden" name="properties[${field.name}]" value="${field.default || ""}" class="js-scProductOption-trigger">`;
      } else {
        // 必須バッジは他の型と全く同じ仕組み（必須の時だけ表示、任意の時は何も出さない）。
        // stamp-editorだけ、確定後に「設定済み」へ切り替えるためのフック用クラスを追加する
        // （必須でない場合はバッジ自体が無いので、確定後の状態表示もしない＝黒箱本来の仕様
        // 「必須→設定済み」のみに合わせる）。
        const stampBadgeHook = field.type === "stamp-editor" ? " scProductOption-stamp-badge" : "";
        formHtml += `<label class="scProductOption-variant-label">${escapeHtml(field.label)}${field.required ? `<span class="scProductOption-required-badge${stampBadgeHook}">必須</span>` : ""}</label>`;

        const nameAttr = `properties[${field.name}]`;
        const def = field.default || "";

        if (field.type === "paired-text") {
          formHtml += `<div class="js-scProductOption-paired-wrapper" data-max-char="${field.maxCharacters}" ${field.required ? `data-required="true" data-error-msg="${escapeHtml(field.errorText)}"` : ""}>
            <div class="scProductOption-paired-row">
              <div class="scProductOption-paired-col"><small>${escapeHtml(field.label1)}</small><input type="text" name="properties[${field.label1}]" class="scProductOption-custom-input js-scProductOption-paired-input js-scProductOption-trigger"></div>
              <div class="scProductOption-paired-col"><small>${escapeHtml(field.label2)}</small><input type="text" name="properties[${field.label2}]" class="scProductOption-custom-input js-scProductOption-paired-input js-scProductOption-trigger"></div>
            </div>
            <div class="scProductOption-char-counter">合計: <span class="js-scProductOption-current-char">0</span> / ${field.maxCharacters}</div>
          </div>`;
        } else if (field.type === "select") {
          formHtml += `<div class="scProductOption-select-wrapper">
            <select name="${nameAttr}" class="scProductOption-custom-select js-scProductOption-trigger" ${field.required ? `data-required="true" data-error-msg="${escapeHtml(field.errorText)}"` : ""}>
              <option value="">選択してください</option>`;
          field.options.forEach((opt) => {
            const isSel = opt.value === def ? "selected" : "";
            formHtml += `<option value="${opt.value}" ${isSel}>${escapeHtml(opt.label)}</option>`;
          });
          formHtml += `</select></div>`;
        } else if (field.type === "image-radio" || field.type === "radio") {
          formHtml += `<div class="scProductOption-option-grid js-scProductOption-selectable-grid" ${field.required ? `data-required="true" data-error-msg="${escapeHtml(field.errorText)}"` : ""}>`;
          field.options.forEach((opt) => {
            const isSel = opt.value === def ? "is-selected" : "";
            formHtml += `<div class="scProductOption-selectable-option js-scProductOption-selectable-option ${isSel}" data-value="${opt.value}">${opt.img ? `<img src="${getFullImgUrl(opt.img)}">` : ""}<span class="scProductOption-option-label">${escapeHtml(opt.label)}</span></div>`;
          });
          formHtml += `</div><input type="hidden" name="${nameAttr}" value="${def}" class="js-scProductOption-hidden-input js-scProductOption-trigger">`;
        } else if (field.type === "image-select") {
          const activeOpt = field.options.find((o) => o.value === def);
          const triggerContent = activeOpt
            ? `<img src="${getFullImgUrl(activeOpt.img)}" class="scProductOption-selected-preview-img"><span class="scProductOption-option-label">${escapeHtml(activeOpt.label)}</span>`
            : "選択してください";
          formHtml += `<div class="scProductOption-image-dropdown js-scProductOption-image-dropdown" ${field.required ? `data-required="true" data-error-msg="${escapeHtml(field.errorText)}"` : ""}>
            <div class="scProductOption-dropdown-trigger js-scProductOption-dropdown-trigger">${triggerContent}</div>
            <div class="scProductOption-dropdown-content"><div class="scProductOption-option-grid js-scProductOption-selectable-grid">`;
          field.options.forEach((opt) => {
            const isSel = opt.value === def ? "is-selected" : "";
            formHtml += `<div class="scProductOption-selectable-option js-scProductOption-selectable-option ${isSel}" data-value="${opt.value}"><img src="${getFullImgUrl(opt.img)}"><span class="scProductOption-option-label">${escapeHtml(opt.label)}</span></div>`;
          });
          formHtml += `</div></div><input type="hidden" name="${nameAttr}" value="${def}" class="js-scProductOption-hidden-input js-scProductOption-trigger"></div>`;
        } else if (field.type === "text" || field.type === "textarea") {
          const isTextarea = field.type === "textarea";
          formHtml += `<${isTextarea ? "textarea" : 'input type="text"'} name="${nameAttr}" class="scProductOption-custom-${isTextarea ? "textarea" : "input"} js-scProductOption-char-limit js-scProductOption-trigger" placeholder="${escapeHtml(field.placeholder || "")}" maxlength="${field.maxCharacters}" data-max-char="${field.maxCharacters}" ${field.required ? `data-required="true" data-error-msg="${escapeHtml(field.errorText)}"` : ""}>${isTextarea ? escapeHtml(def) + "</textarea>" : ""}`;
          if (!isTextarea) formHtml = formHtml.replace(/>$/, ` value="${escapeHtml(def)}">`);
          if (field.maxCharacters) formHtml += `<div class="scProductOption-char-counter"><span class="js-scProductOption-current-char">${def.length}</span> / ${field.maxCharacters}</div>`;
        } else if (field.type === "checkbox" || field.type === "confirm") {
          const isConfirm = field.type === "confirm";
          formHtml += `<div class="scProductOption-checkbox-group ${isConfirm ? "js-scProductOption-confirm-group" : ""}" ${field.required ? `data-required="true" data-error-msg="${escapeHtml(field.errorText)}"` : ""}>`;
          if (field.options) {
            field.options.forEach((opt) => {
              const isChecked = opt.default === true || opt.default === "true" ? "checked" : "";
              formHtml += `<label class="scProductOption-checkbox-container"><input type="checkbox" name="properties[${opt.label}]" class="js-scProductOption-trigger" ${isChecked}> ${escapeHtml(opt.label)}</label>`;
            });
          }
          formHtml += `</div>`;
        } else if (field.type === "file") {
          formHtml += `<input type="file" name="${nameAttr}" class="scProductOption-custom-input js-scProductOption-trigger" ${field.required ? `data-required="true" data-error-msg="${escapeHtml(field.errorText)}"` : ""}>`;
        } else if (field.type === "stamp-editor") {
          // 版下エディタ（backend/cloudflare/worker/assets/stamp-editor/）を1フィールドとして
          // 埋め込む。data-show-preview="false"でウィジェット自前のプレビューUIは出さず、
          // 見た目は他のフィールド型と揃えるため独自のプレビュー画像枠(*-preview)を用意する。
          // field.handle はShopifyの商品ハンドルに依存しない、テンプレートフォルダ名の直接指定
          // （商品ハンドルとテンプレート命名を無理に一致させる必要がない。2026-09-04方針）。
          //
          // data-target-*（CSSセレクタで親ページの要素にウィジェット側が直接書き込む仕組み）は
          // 使わない。ウィジェット本体はiframe内で動いており、iframeの中からは
          // document.querySelectorで親ページ（このフォーム）の要素を見つけられないため、
          // 実機で書き込みが発生しないことを確認した（2026-09-04）。代わりにstamp:confirmed
          // イベント（bubbles:trueで発火、e.detailにjson/image/codeが入る）を親ページ側
          // （このファイル、下記のイベントリスナー）で拾って自分たちで値を書き込む。
          // data-show-button="false"・data-show-preview="false"でウィジェット内蔵のUI（見出し・
          // ボタン・バッジ・プレビュー枠）は出さず、同等の状態表示（バッジ／点線→実線の
          // プレビュー枠／プレースホルダー／再編集ボタン化）を自前で用意し、カート追加ボタン
          // （.add-cart-btn）とデザインを揃える。挙動は導入ガイド.txt 7節・仕様_共通.txt 13-3節
          // （data-sew-badge / data-sew-preview / data-sew-placeholder / data-sew-img-wrap /
          // data-sew-img / data-sew-edit-btn）の状態遷移を参考にしている。
          const stampId = `scProductOption-stamp-${field.name}`;
          formHtml += `
            <div class="scProductOption-stamp-preview-area">
              <span class="scProductOption-stamp-placeholder">まだ作成されていません</span>
              <div class="scProductOption-stamp-img-wrap" hidden>
                <img class="scProductOption-stamp-img" alt="作成したスタンプデザイン">
              </div>
            </div>
            <div id="${stampId}-widget" data-stamp-widget
              data-base="${STAMP_EDITOR_BASE}"
              data-name="${escapeHtml(productTitle)}"
              data-handle="${escapeHtml(field.handle || "")}"
              data-passcode="${escapeHtml(stampEditorPasscode)}"
              data-show-preview="false"
              data-show-button="false">
            </div>
            <button type="button" class="scProductOption-stamp-btn" data-stamp-open-btn="${stampId}-widget"><span class="scProductOption-stamp-btn-icon" aria-hidden="true">✎</span><span class="scProductOption-stamp-btn-label">スタンプデザインを作成する</span></button>
            ${stampGuideUrl ? `<a href="${escapeHtml(stampGuideUrl)}" target="_blank" class="scProductOption-stamp-guide-link">スタンプエディタの使い方 ›</a>` : ""}
            <input type="hidden" name="${nameAttr}" id="${stampId}-code" class="js-scProductOption-trigger js-scProductOption-stamp-code" ${field.required ? `data-required="true" data-error-msg="${escapeHtml(field.errorText)}"` : ""}>
            <input type="hidden" name="properties[${field.name}(レイアウト)]" id="${stampId}-json">
            <input type="file" name="properties[${field.name}(版下データ)]" id="${stampId}-image" hidden>
            <input type="hidden" name="properties[${field.name}(タイプ)]" id="${stampId}-mode">
          `;
        }
        formHtml += `<div class="scProductOption-error-message-placeholder"></div>`;
      }
      formHtml += `</div>`;
    });
    container.innerHTML = formHtml;

    if (hasStampEditorField) {
      if (window.StampEmbed && typeof window.StampEmbed.initEl === "function") {
        // 2回目以降（カート追加後のリセット等でrenderFields()を再実行した場合）は
        // stamp-embed.js自体は既に読み込み済みなので、スクリプトの再読み込みはせず、
        // 公開API（StampEmbed.initEl）で新しく生成されたウィジェット要素だけを初期化する。
        // 内部のinit()も実質同じ処理（[data-stamp-widget]走査→initElと同じ生成）をしている。
        container.querySelectorAll("[data-stamp-widget]").forEach((el) => window.StampEmbed.initEl(el));
      } else {
        // stamp-embed.js自体は読み込み時に一度だけ[data-stamp-widget]要素を走査してボタン等を
        // 差し込む仕組みで、後から追加された要素までは拾ってくれない（版下エディタ側の実装、
        // 変更不可）。このcontainer.innerHTML代入（直前の行）で[data-stamp-widget]が今まさに
        // DOMに現れた直後というタイミングでスクリプトを動的に読み込むことで、
        // 静的にHTMLへ書いた場合と同じ順序関係を保証する（2026-09-04、実機でレース
        // コンディションを発見・修正。<script defer>をLiquid側に静的に置くと、
        // このJSによる動的生成より早く走査が終わってしまいボタンが出なかった）。
        const script = document.createElement("script");
        script.src = STAMP_EDITOR_BASE + "stamp-embed.js";
        document.body.appendChild(script);
      }
    }

    container.querySelectorAll(".js-scProductOption-selectable-option").forEach((option) => {
      option.addEventListener("click", function (e) {
        e.stopPropagation();
        const wrapper = this.closest("[data-field-wrapper]");
        const grid = this.closest(".js-scProductOption-selectable-grid");
        grid.querySelectorAll(".js-scProductOption-selectable-option").forEach((el) => el.classList.remove("is-selected"));
        this.classList.add("is-selected");
        wrapper.querySelector(".js-scProductOption-hidden-input").value = this.getAttribute("data-value");

        if (this.closest(".scProductOption-image-dropdown")) {
          const dropdown = this.closest(".scProductOption-image-dropdown");
          const trigger = dropdown.querySelector(".js-scProductOption-dropdown-trigger");
          trigger.innerHTML = this.innerHTML;
          const img = trigger.querySelector("img");
          if (img) img.classList.add("scProductOption-selected-preview-img");
          dropdown.classList.remove("is-open");
        }
        evaluateConditions();
      });
    });

    container.querySelectorAll(".js-scProductOption-dropdown-trigger").forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.stopPropagation();
        trigger.closest(".js-scProductOption-image-dropdown").classList.toggle("is-open");
      });
    });

    // 独自ボタン（data-show-button="false"のため）クリックでStampEmbed.open()を呼ぶ
    // （導入ガイド.txt 7節）。stamp-embed.jsの読み込みタイミングに関わらず動くよう、
    // クリック時点でwindow.StampEmbedを参照する。
    container.querySelectorAll("[data-stamp-open-btn]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const widgetId = btn.getAttribute("data-stamp-open-btn");
        const widget = document.getElementById(widgetId);
        if (widget && window.StampEmbed && typeof window.StampEmbed.open === "function") {
          window.StampEmbed.open(widget);
          stampReturnBtn = btn;

          // 版下エディタはページ全体を覆うモーダル（.sew-modal）として開き、閉じる時は
          // hidden属性を付け直すだけ（stamp-embed.js側の実装、変更不可・公開APIにclose相当なし）。
          // 閉じた瞬間に、開いた時のボタンの位置までスクロールを戻す。モーダル要素自体は
          // 全フィールド共通のシングルトンなので、監視は最初の1回だけ設定すればよい。
          if (!stampModalObserver) {
            const modal = document.querySelector(".sew-modal");
            if (modal) {
              stampModalObserver = new MutationObserver(() => {
                if (modal.hasAttribute("hidden") && stampReturnBtn) {
                  stampReturnBtn.scrollIntoView({ block: "center", behavior: "smooth" });
                }
              });
              stampModalObserver.observe(modal, { attributes: true, attributeFilter: ["hidden"] });
            }
          }
        }
      });
    });

    // 版下エディタ確定時。data-target-*は使わない方針にしたため（上記コメント参照）、
    // stamp:confirmedイベント（stamp-embed.jsがbubbles:trueで発火、e.detailにjson/image/code）
    // を自前で受け取り、対応するhidden input / file input / 状態表示（バッジ・枠・ボタン文言）
    // へ書き込む。状態遷移はビルトインUI（data-sew-badge等、仕様_共通.txt 13-3節）を参考にした。
    container.querySelectorAll("[data-stamp-widget]").forEach((widget) => {
      widget.addEventListener("stamp:confirmed", (e) => {
        const wrapper = widget.closest("[data-field-wrapper]");
        if (!wrapper) return;
        const { json, image, code } = e.detail || {};

        // 確定してもモーダルはすぐには閉じない（stamp-embed.js側の仕様）ため、ボタン位置への
        // スクロールをここでも行っておく。モーダルは position:fixed の全画面オーバーレイなので、
        // 開いたまま裏側でページをスクロールしても見た目には影響しない
        // （後でモーダルを閉じた時には既に正しい位置になっている）
        if (stampReturnBtn) stampReturnBtn.scrollIntoView({ block: "center", behavior: "smooth" });

        const codeInput = wrapper.querySelector(".js-scProductOption-stamp-code");
        if (codeInput) codeInput.value = code || "";

        // jsonは文字列で来る場合とオブジェクトで来る場合があるため、一度だけ正規化して両方に使う。
        let parsedJson = json;
        if (typeof json === "string") {
          try { parsedJson = JSON.parse(json); } catch (e) { parsedJson = {}; }
        }
        parsedJson = parsedJson || {};

        const jsonInput = wrapper.querySelector('input[id$="-json"]');
        if (jsonInput) jsonInput.value = JSON.stringify(parsedJson);

        // 価格区分（A/B）を、商品オプションの表示条件（variation型のcondition）から
        // 参照できるよう別プロパティとして出力する。エディタ種別（easy/free/date）や
        // 日付印の円弧レイアウト有無を個別に判定する必要はなく、Preview側が確定出力JSONに
        // 直接stamp_type（"A"|"B"）として計算済みの値を入れてくれるため、そのまま読むだけ
        // でよい（2026-09-30対応。以前の`(エディタ)`サフィックス・`editor`参照は不要になり
        // `(タイプ)`・`stamp_type`に置き換え）。stamp_typeが省略されている場合はA扱い。
        const modeInput = wrapper.querySelector('input[id$="-mode"]');
        if (modeInput) modeInput.value = parsedJson.stamp_type || "A";

        const fileInput = wrapper.querySelector('input[type="file"]');
        const previewArea = wrapper.querySelector(".scProductOption-stamp-preview-area");
        const placeholder = wrapper.querySelector(".scProductOption-stamp-placeholder");
        const imgWrap = wrapper.querySelector(".scProductOption-stamp-img-wrap");
        const img = wrapper.querySelector(".scProductOption-stamp-img");
        const badge = wrapper.querySelector(".scProductOption-stamp-badge");
        const openBtnLabel = wrapper.querySelector(".scProductOption-stamp-btn-label");

        const applyFile = (file) => {
          if (fileInput && file) {
            const dt = new DataTransfer();
            dt.items.add(file);
            fileInput.files = dt.files;
          }
        };

        const markDone = (src) => {
          if (previewArea) previewArea.classList.add("is-done");
          if (placeholder) placeholder.hidden = true;
          if (imgWrap) imgWrap.hidden = false;
          if (img && src) img.src = src;
          if (badge) { badge.textContent = "設定済み"; badge.classList.add("is-done"); }
          if (openBtnLabel) openBtnLabel.textContent = "再編集する";
        };

        if (image instanceof File) {
          applyFile(image);
          markDone(URL.createObjectURL(image));
        } else if (typeof image === "string" && image.startsWith("data:")) {
          // stamp-embed.jsはimageをdata URL文字列で渡してくる。
          // プレビューはそのまま表示できるが、カート送信用には実バイナリのFileへ変換する。
          markDone(image);
          fetch(image)
            .then((res) => res.blob())
            .then((blob) => {
              const ext = (blob.type.split("/")[1] || "png").split("+")[0];
              applyFile(new File([blob], `stamp.${ext}`, { type: blob.type }));
            });
        }

        evaluateConditions();
      });
    });

    container.querySelectorAll(".js-scProductOption-trigger").forEach((input) => {
      const handleEvent = () => {
        if (input.classList.contains("js-scProductOption-char-limit")) {
          const current = input.value.length;
          input.closest("[data-field-wrapper]").querySelector(".js-scProductOption-current-char").innerText = current;
        }
        if (input.classList.contains("js-scProductOption-paired-input")) {
          const wrap = input.closest(".js-scProductOption-paired-wrapper");
          let total = 0;
          wrap.querySelectorAll(".js-scProductOption-paired-input").forEach((i) => (total += i.value.length));
          wrap.querySelector(".js-scProductOption-current-char").innerText = total;
          wrap.querySelector(".scProductOption-char-counter").style.color = total > parseInt(wrap.dataset.maxChar) ? "var(--red)" : "var(--sub)";
        }
        evaluateConditions();
      };
      input.addEventListener("input", handleEvent);
      input.addEventListener("change", handleEvent);
    });

    evaluateConditions();
    }

    // ドロップダウン（image-select型）の外側クリックで閉じる。renderFields()を何度呼び直しても
    // documentへのリスナーが重複登録されないよう、ここでは最初の1回だけ登録する
    document.addEventListener("click", () => {
      container.querySelectorAll(".js-scProductOption-image-dropdown").forEach((d) => d.classList.remove("is-open"));
    });

    function validateForm() {
      let isValid = true;
      container.querySelectorAll(".scProductOption-field-error-text").forEach((el) => el.remove());
      container.querySelectorAll(".scProductOption-input-error").forEach((el) => el.classList.remove("scProductOption-input-error"));

      container.querySelectorAll('[data-required="true"]').forEach((el) => {
        const wrapper = el.closest(".scProductOption-field-wrapper");
        if (wrapper.classList.contains("is-hidden")) return;

        let hasError = false;
        if (el.classList.contains("js-scProductOption-paired-wrapper")) {
          const max = parseInt(el.dataset.maxChar);
          let total = 0;
          el.querySelectorAll(".js-scProductOption-paired-input").forEach((i) => (total += i.value.trim().length));
          if (total === 0 || total > max) hasError = true;
        } else if (el.classList.contains("js-scProductOption-confirm-group")) {
          const totalCheckboxes = el.querySelectorAll('input[type="checkbox"]').length;
          const checkedCount = el.querySelectorAll('input[type="checkbox"]:checked').length;
          if (checkedCount < totalCheckboxes) hasError = true;
        } else if (el.classList.contains("scProductOption-checkbox-group")) {
          const checkedCount = el.querySelectorAll('input[type="checkbox"]:checked').length;
          if (checkedCount === 0) hasError = true;
        } else {
          const inputEl = wrapper.querySelector('[name^="properties["]');
          if (inputEl) {
            const hasVal = inputEl.type === "file" ? inputEl.files.length > 0 : inputEl.value.trim() !== "";
            if (!hasVal) hasError = true;
          }
        }

        if (hasError) {
          isValid = false;
          el.classList.add("scProductOption-input-error");
          const err = document.createElement("span");
          err.className = "scProductOption-field-error-text";
          err.innerText = `⚠️ ${el.dataset.errorMsg}`;
          wrapper.querySelector(".scProductOption-error-message-placeholder").appendChild(err);
        }
      });

      if (!isValid) {
        const firstError = container.querySelector(".scProductOption-input-error");
        if (firstError) window.scrollTo({ top: firstError.getBoundingClientRect().top + window.pageYOffset - 150, behavior: "smooth" });
      }
      return isValid;
    }

    // カート追加成功後、商品オプションを初期状態に戻すためのリセット関数（initCartFormから呼ぶ）
    function resetFields() {
      renderFields();
    }

    renderFields();
    return { validateForm, resetFields };
  }

  // サムネイルクリックでメイン画像を切り替える。
  function initGallery() {
    const mainImg = document.querySelector("[data-gallery-main-img]");
    const thumbs = document.querySelectorAll("[data-gallery-thumb]");
    if (!mainImg || thumbs.length === 0) return;
    mainImg.addEventListener("load", () => mainImg.classList.remove("is-swapping"));
    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        if (mainImg.src === thumb.dataset.galleryThumb) return;
        mainImg.classList.add("is-swapping");
        mainImg.src = thumb.dataset.galleryThumb;
        thumbs.forEach((t) => t.classList.toggle("is-selected", t === thumb));
      });
    });
  }

  // アコーディオン（商品説明/仕様/発送について/FAQ/レビュー）の中身はLiquid側でSSR済み
  // （メタフィールド _sc.spec/_sc.shipping_note/_sc.faq/_sc.review）。ここでは開閉のみを扱う。
  function initAccordions() {
    document.querySelectorAll("[data-accordion-toggle]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const body = btn.nextElementSibling;
        if (!body) return;
        const isOpen = !body.hidden;
        body.hidden = isOpen;
        btn.setAttribute("aria-expanded", String(!isOpen));
        const arrow = btn.querySelector(".accordion-arrow");
        if (arrow) arrow.textContent = isOpen ? "＋" : "－";
      });
    });
  }

  // 数量ステッパー・カート追加ボタン。フォームのquantity/id隠しinputを最新の状態にしてから
  // 独自Ajax Cart API（addItem）で送信する（ページ遷移はしない、2026-08-19方針決定）。
  function initCartForm(productOptions) {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const qtyDisplay = document.querySelector("[data-qty]");
    const qtyInput = form.querySelector("[data-qty-input]");
    const variantIdInput = form.querySelector("[data-variant-id-input]");
    const addBtn = document.querySelector("[data-add-cart]");
    const errorBox = form.querySelector(".main-product__error");
    let qty = 1;

    function setQty(newQty) {
      qty = Math.max(1, Math.floor(newQty) || 1);
      qtyDisplay.value = String(qty);
      if (qtyInput) qtyInput.value = String(qty);
    }

    // ＋－ボタンは通常クリックで1ずつ、長押しで連続加算（大口注文で入力しやすいように）。
    // 長押しが発動した後は、指を離した時に発生するclickイベントで二重に加算されないよう
    // longPressedフラグで打ち消す。
    function bindQtyHold(btn, step) {
      let holdTimeout = null;
      let holdInterval = null;
      let longPressed = false;

      const stopHold = () => {
        clearTimeout(holdTimeout);
        clearInterval(holdInterval);
        holdTimeout = null;
        holdInterval = null;
      };

      btn.addEventListener("pointerdown", (e) => {
        if (e.button !== 0) return;
        longPressed = false;
        holdTimeout = setTimeout(() => {
          longPressed = true;
          holdInterval = setInterval(() => setQty(qty + step), 80);
        }, 400);
      });
      ["pointerup", "pointerleave", "pointercancel"].forEach((evt) => btn.addEventListener(evt, stopHold));

      btn.addEventListener("click", () => {
        if (longPressed) {
          longPressed = false;
          return;
        }
        setQty(qty + step);
      });
    }

    bindQtyHold(document.querySelector("[data-qty-dec]"), -1);
    bindQtyHold(document.querySelector("[data-qty-inc]"), 1);

    // 数量を直接入力できるようにする（大口注文で＋を何度も押すのは面倒なため）。
    // Enterキーでのフォーム誤送信を防ぐため、Enterはblur扱いにしてchangeへ流す。
    qtyDisplay.addEventListener("change", () => setQty(parseInt(qtyDisplay.value, 10)));
    qtyDisplay.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        qtyDisplay.blur();
      }
    });

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      if (errorBox) errorBox.textContent = "";

      if (addBtn.hasAttribute("data-sold-out")) {
        if (errorBox) errorBox.textContent = "この商品は売り切れです。";
        return;
      }

      if (productOptions && !productOptions.validateForm()) return;

      const variantId = variantIdInput ? variantIdInput.value : null;
      if (!variantId) {
        if (errorBox) errorBox.textContent = "商品バリエーションを取得できませんでした。";
        return;
      }

      const properties = {};
      form.querySelectorAll('[name^="properties["]').forEach((el) => {
        // 表示条件で非表示（disabled）になっているフィールドは、以前の入力値が残っていても
        // 送信対象から除外する（表示条件を切り替えた際に、隠れた側の値が混入するのを防ぐ）
        if (el.disabled) return;
        const key = el.name.replace("properties[", "").replace("]", "");
        if (el.type === "checkbox") {
          if (el.checked) properties[key] = "はい";
        } else if (el.type === "file") {
          // 版下エディタが data-target-image 経由でDataTransferにより.filesへ実ファイルを
          // セットする（導入ガイド4節）。.valueは偽のパス文字列なので使わない。
          if (el.files && el.files[0]) properties[key] = el.files[0];
        } else if (el.value) {
          properties[key] = el.value;
        }
      });

      const defaultLabel = addBtn.dataset.defaultLabel || (addBtn.dataset.defaultLabel = addBtn.textContent);

      addBtn.disabled = true;
      addBtn.classList.add("is-loading");
      addBtn.innerHTML = `<span class="plp-cart-spinner" aria-hidden="true"></span><span class="visually-hidden">追加中...</span>`;
      addItem({ id: variantId, quantity: qty, properties: Object.keys(properties).length ? properties : undefined })
        .then(() => {
          addBtn.classList.remove("is-loading");
          addBtn.textContent = "追加しました ✓";
          addBtn.classList.add("is-added");

          // 追加後もオプションが入力済みのまま残っていると「本当に追加されたのか」が
          // 分かりにくいため、数量・商品オプション（版下エディタ含む）を初期状態に戻す
          // （2026-09-30方針。版下エディタは履歴からすぐ復元できるため、作り直しコストは低い）
          setQty(1);
          if (productOptions && productOptions.resetFields) productOptions.resetFields();

          setTimeout(() => {
            addBtn.textContent = defaultLabel;
            addBtn.classList.remove("is-added");
            addBtn.disabled = false;
          }, 1800);
        })
        .catch((err) => {
          console.error("カートへの追加に失敗しました:", err);
          if (errorBox) errorBox.textContent = "カートへの追加に失敗しました。時間をおいて再度お試しください。";
          addBtn.classList.remove("is-loading");
          addBtn.textContent = defaultLabel;
          addBtn.disabled = false;
        });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    const productOptions = initProductOptions();
    initCartForm(productOptions);
    initGallery();
    initAccordions();
    // 「よく一緒に購入される商品」「あなたへのおすすめ」はプレースホルダーだけLiquidが出し、
    // 中身はrecommendations.jsがfetchして差し込む（sections/product-recommendations.liquid）。
    loadRecommendationBlocks();
    bindAddToCartButtons(document.body);
  });
})(window.SANBY);
